import React from "react";

const Card = ({ name, email, id }) => {
  //accepts the properties defined in the index.js asking for id name and email
  return (
    <fragment className="tc bg-light-blue dib br3 pa3 ma2 grow bw2 shadow-5">
      <img src={`https://robohash.org/${id}?200x200?`} alt="" />
      <div>
        <h2>{name}</h2>
        {/* The name defined in robots.js and called in index.js . Uses the curly brackets to use the javascript*/}
        <p>{email}</p>
      </div>
    </fragment>
  );
};

export default Card;
